import MonthNavigator from './Statistics/MonthNavigator';
import { StatisticsProvider } from './Statistics/StatiscticsContext';
import StatisticsSummary from './Statistics/StatisticsSummary';
import { useStatistics } from './Statistics/StatiscticsContext';
import StatisticsCalendar from './Statistics/StatisticsCalendar';
import StatisticsDaily from './Statistics/StatisticsDaily';
import BarChartSection from './Statistics/BarChartSection';
import StoreChartSection from './Statistics/StoreChartSection';
import MarketChartSection from './Statistics/MarketChartSection';
import ProductSalesSection from './Statistics/ProductSalesSection';
import AlertDialog from '@/components/dashboard/alert-dialog';

const StatisticsPc = () => {
  return (
    <StatisticsProvider>
      <AlertDialog />
      <StatisticsPcContent />
    </StatisticsProvider>
  );
};

export default StatisticsPc;

const StatisticsPcContent = () => {
  const { isLoading, isRegisteredMarket, totalSalesAmount } = useStatistics();
  const showOverlay = !isRegisteredMarket || totalSalesAmount === 0;

  return (
    <div className="scrollbar relative flex h-full w-full flex-1 flex-col gap-[16px] overflow-y-auto">
      {isLoading && <FullScreenSpinner />}
      <div className="mx-auto flex h-full w-full max-w-full flex-1 flex-col gap-[16px] p-[40px] px-[60px]">
        <div className="flex w-full flex-col gap-6">
          <div className="flex flex-col gap-[12px]">
            <div className="text-gr-900 Title2S24">통계</div>
            <MonthNavigator />
          </div>
          <div className="grid ">
            <StatisticsSummary />
          </div>
          <div className="grid grid-cols-1 gap-[16px] md:grid-cols-2">
            <div className="text-gr-900 Title2S24">
              <StatisticsCalendar />
            </div>
            <div className="text-gr-600 Body1S16">
              <StatisticsDaily />
            </div>
          </div>
          <div
            className={`relative flex flex-col gap-[24px] ${
              showOverlay && 'max-h-[348px] overflow-hidden rounded-[16px]'
            }`}
          >
            {showOverlay && (
              <>
                {/* <div className="pointer-events-auto absolute left-0 top-0 z-10 h-[348px] w-full bg-white/80" /> */}
                <div className="overlay-gradient h-[348px] " />

                <div className="absolute bottom-[40px] left-0 z-20 flex w-full justify-center">
                  <span className=" text-gr-700 Body1S16">
                    판매가 발생하면 분석 결과가 업데이트 돼요
                  </span>
                </div>
              </>
            )}

            <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
              <BarChartSection />
              <StoreChartSection />
              <MarketChartSection />
            </div>
            <div className="grid">
              <ProductSalesSection />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const FullScreenSpinner = () => (
  <div className="fixed inset-0 z-50 flex items-center justify-center  ">
    <svg className="h-12 w-12 animate-spin text-violet-500" viewBox="0 0 24 24">
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
        fill="none"
      />
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
    </svg>
    <span className="ml-4 text-lg font-semibold text-violet-700">로딩 중...</span>
  </div>
);
